import {
  windowDimensionsStore,
  WindowDimensionsEvent,
} from "../components/window-dimensions-provider"
import { useEventEmitterValue } from "./use-event-emitter-value"

const useWindowDimensions = ({
  debounceMs = 250,
  updateOnHeightChange = false,
}: {
  debounceMs?: number
  /**
   * Listen for height changes. This allows the caller to listen to resize
   * changes triggered by mobile web browsers that collapse their address
   * bar/footer when the user scrolls. Listening to these changes is more
   * expensive so it's an opt-in feature.
   */
  updateOnHeightChange?: boolean
} = {}) => {
  const windowDimensions = useEventEmitterValue(
    windowDimensionsStore,
    updateOnHeightChange
      ? WindowDimensionsEvent.Updated
      : WindowDimensionsEvent.WidthUpdated,
    windowDimensionsStore.get,
    debounceMs,
  )

  if (!windowDimensions) {
    throw new Error(
      "useWindowDimensions was rendered outside the WindowDimensionProvider component",
    )
  }

  return windowDimensions
}

/**
 * Suspend all window dimension updates. This is used when an orientation change
 * is expected for the video player and we don't want to thrash the app UI
 * behind the video player.
 */
export const suspendWindowDimensionUpdates = windowDimensionsStore.suspend

/**
 * Resume window dimension updates the next time they change
 */
export const resumeWindowDimensionUpdates = windowDimensionsStore.resume

export default useWindowDimensions
